import { inject, Injectable, signal } from '@angular/core';
import { SupabaseService } from '../auth/supabase.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly supabase = inject(SupabaseService).client;

  private readonly _permissions = signal<ReadonlySet<string>>(new Set());
  readonly permissions = this._permissions.asReadonly();

  /**
   * Re-reads crm.my_permissions(). A FAILED call keeps the set already held: an
   * error is not "you have no permissions", and emptying the set on a blip sent
   * a working user to /no-access (crmAccessGuard) and hid the whole sidebar.
   * Only clear() — on sign-out — empties it.
   */
  async refresh(): Promise<void> {
    const { data, error } = await this.supabase.schema('crm').rpc('my_permissions');

    if (error) {
      return;
    }

    this._permissions.set(new Set((data ?? []) as string[]));
  }

  can(key: string): boolean {
    return this._permissions().has(key);
  }

  /** True if the user holds at least one CRM permission (i.e. has a role granting access). */
  hasAnyPermission(): boolean {
    return this._permissions().size > 0;
  }

  clear(): void {
    this._permissions.set(new Set());
  }
}
